// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file user_confirmation_data.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { UserConfirmationType } from "./user_confirmation_type_pb";
import { file_user_confirmation_type } from "./user_confirmation_type_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file user_confirmation_data.proto.
 */
export const file_user_confirmation_data: GenFile = /*@__PURE__*/
  fileDesc("Chx1c2VyX2NvbmZpcm1hdGlvbl9kYXRhLnByb3RvEgZkb21haW4ijwEKFFVzZXJDb25maXJtYXRpb25EYXRhEioKBHR5cGUYASABKA4yHC5kb21haW4uVXNlckNvbmZpcm1hdGlvblR5cGUSDwoHdmF1bHRJZBgCIAEoCRIPCgdsb2dpbklkGAMgASgJEhEKCXByb2ZpbGVJZBgEIAEoCRIWCg5vcmdhbml6YXRpb25JZBgFIAEoCUIwWi5naXRsYWIuY29tL2NvdGVjaGRlL21vbm9yZXBvL2JhY2tlbmQvZG9tYWluL3BiYgZwcm90bzM", [file_user_confirmation_type]);

/**
 * @generated from message domain.UserConfirmationData
 */
export type UserConfirmationData = Message<"domain.UserConfirmationData"> & {
  /**
   * @generated from field: domain.UserConfirmationType type = 1;
   */
  type: UserConfirmationType;

  /**
   * similar to AuditlogEvent, so that ones can be derived from this
   *
   * @generated from field: string vaultId = 2;
   */
  vaultId: string;

  /**
   * @generated from field: string loginId = 3;
   */
  loginId: string;

  /**
   * @generated from field: string profileId = 4;
   */
  profileId: string;

  /**
   * @generated from field: string organizationId = 5;
   */
  organizationId: string;
};

/**
 * Describes the message domain.UserConfirmationData.
 * Use `create(UserConfirmationDataSchema)` to create a new message.
 */
export const UserConfirmationDataSchema: GenMessage<UserConfirmationData> = /*@__PURE__*/
  messageDesc(file_user_confirmation_data, 0);

